/** WebRTC signaling control ops — carried inside sealed envelopes (app E2EE). */

export const CONTENT_TYPE_SIGNAL = 8;

export type SignalOp =
  | { op: "webrtc-offer"; sdp: string }
  | { op: "webrtc-answer"; sdp: string }
  | { op: "webrtc-ice"; candidate: string }
  /** Elected initiator announces durable session so the collide peer can adopt + re-seal. */
  | { op: "session-supersede" };

export function encodeSignal(op: SignalOp): string {
  return JSON.stringify(op);
}

/** A session description is a few KB; anything far larger is junk (each one costs a WebRTC parse). */
export const MAX_SIGNAL_SDP_CHARS = 16_384;

export function decodeSignal(body: string): SignalOp | null {
  try {
    const raw = JSON.parse(body) as SignalOp;
    if (!raw || typeof raw !== "object" || !("op" in raw)) return null;
    if (raw.op === "webrtc-offer" || raw.op === "webrtc-answer") {
      const sdp = (raw as { sdp?: unknown }).sdp;
      return typeof sdp === "string" && sdp.length > 0 && sdp.length <= MAX_SIGNAL_SDP_CHARS ? { op: raw.op, sdp } : null;
    }
    if (raw.op === "webrtc-ice") {
      const candidate = (raw as { candidate?: unknown }).candidate;
      return typeof candidate === "string" && candidate.length <= 2048 ? { op: raw.op, candidate } : null;
    }
    if (raw.op === "session-supersede") return { op: raw.op };
    return null;
  } catch {
    return null;
  }
}
